import Card, { CardProps } from '../../card/Card';
import Grid, { GridType } from '../Grid';

interface ModelProps {
  componentName: string;
  model: {
    items: CardProps[];
  };
}

// interface CategorySelectorProps {
//   items: CardProps[];
// }

const CategorySelector = (props: ModelProps) => {
  return (
    <>
      <div className="c-griddy  u-margin-top u-margin-bottom">
        <div className="o-wrapper">
          <Grid type={GridType.FULL_WIDTH} columns={4}>
            {props.model.items.map((item, index) => (
              <Card
                {...item}
                hasHtmlDescription={true}
                key={`system-selector-card-${index}`}
              />
            ))}
          </Grid>
        </div>
      </div>
    </>
  );
};

export default CategorySelector;
